export const SET_ORGANISATION_STRUCTURE = "SET_ORGANISATION_STRUCTURE";
export const SET_CITIES = "SET_CITIES";
export const SET_STATES = "SET_STATES";
export const SET_DIVISIONS = "SET_DIVISIONS";
export const SET_SUB_DIVISIONS = "SET_SUB_DIVISIONS";
export const SET_POSITIONS = "SET_POSITIONS";
export const SET_PROFESSIONS = "SET_PROFESSIONS";
export const SET_SPECIAL_GROUP = "SET_SPECIAL_GROUP";
export const SET_PERIOD_DATE = "SET_PERIOD_DATE";
export const SET_ROLES = "SET_ROLES";
